// extracted by mini-css-extract-plugin
export default {"class_card":"class_card__Kq2hE","classTitle":"classTitle__o7IIv","lesson_item":"lesson_item__Ee8As","lesson_icon":"lesson_icon__Swx0x"};